export default {
    "public-text": "Client's Extranet",
    "navigation": {
        "home": "Home",
        "invoices": "Invoices",
        "delivery-notes": "Delivery Notes",
        "stocks": "Stocks",
        "services": "Services",
        "technical-sheets": "Technical Sheets",
        "packing-lists": "Packing Lists",
        "admin-home": "Home",
        "clients": "Clients",
        "users": "Users",
        "audit": "Audit",
        "executions": "Data executions",
        "documentation": "Documentation",
        "transportation": "Transport"
    }
};